import { initReact } from '../../../Shared/js/vendor/react';
import * as TabletsComponents from './components';

function initTabletsComponents() {
    initReact();
    window.TabletsComponents = window.TabletsComponents || TabletsComponents;
}

initTabletsComponents();
